export default "__VITE_ASSET__BO7_AA26__"